import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { SsoRedirectDialogComponent, SsoRedirectDialogData } from '../components/sso-redirect-dialog/sso-redirect-dialog.component';

// Ponto único p/ qualquer botão de aplicação da homepage abrir a confirmação de redirecionamento SSO.
@Injectable({ providedIn: 'root' })
export class SsoRedirectDialogService {
  constructor(private readonly dialog: MatDialog) {}

  confirm(appTitle: string, trigram: string): void {
    const data: SsoRedirectDialogData = { appTitle, trigram };
    this.dialog.open(SsoRedirectDialogComponent, {
      width: '580px',
      maxWidth: 'calc(100vw - 32px)',
      panelClass: 'sso-redirect-panel',
      ariaLabelledBy: 'sso-redirect-title',
      data
    });
  }
}
